
// import webconfig from "../../../config/web";
import { getHqDate } from "../apidata";
const webconfig = require("../../../config/web")

/**
 * 指数行情
 * @returns 
 */
export let getZSHQData = async () => {
  try {
    let _url: string = `${webconfig.getWebPath("push2")}api/qt/clist/get?pi=0&pz=10&po=1&np=1&fields=f1,f2,f3,f4,f12,f13,f14&fltt=2&invt=2&ut=13697a1cc677c8bfa9a496437bfef419&fs=i:1.000001,i:0.399001,i:0.399006,i:100.HSI,i:100.DJIA`
    let json = await getHqDate(_url)
    if (!(json && json.data && json.data.diff)) {
      return;
    }
    let data = json.data.diff;

    return data || []
  } catch (error) {
    return []
  }
}


/**
 * 获取个股info
 * @returns 
 */
export let getStockInfo = async (mk: string|number, code: string) => {
  let mkcode = mk + '.' + code
  try {
    let _url: string = `${webconfig.getWebPath("push2")}api/qt/stock/get?invt=2&fltt=1&fields=f181,f58,f59,f111&secid=${mkcode}&ut=13697a1cc677c8bfa9a496437bfef419&wbp2u=2924305535875976|0|1|0|web`
    let json = await $.ajax({
      url: _url,
      method: "GET",
      dataType: "jsonp",
      jsonp: "cb"
    })
    if (!(json && json.data)) {
      return [];
    }
    let data = json.data || [];

    return data
  } catch (error) {
    return []
  }
}